import { AsynchronousNotification } from "../../../models/AsynchronousNotification";
import { text } from "../../../utils/i18n";

/**
 * Returns a new instance of AsynchronousNotification which is used for asking permission
 * to show system notifications, outside of the browser tab.
 */
export function createSystemNotificationPermissionRequest(
  options: Optional<Omit<Partial<AsynchronousNotification>, 'id'>, 'actions'>
): AsynchronousNotification {
  return new AsynchronousNotification({
    ...options,
    id: "requestNotificationPermission", // Ensures that the notification does not appear twice, since each notification has the same intention.
    actions: {
      confirm: {
        onClick: params => {
          options.actions?.confirm?.onClick(params);
          window.Notification.requestPermission();
        },
        children: options.actions?.confirm?.children || text`Tillåt aviseringar`
      }
    }
  })
}